
let Data = [
  {
    id: Math.random() * 10,
    name: "Doc_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Date",
        label: "Date",
        type: "Date",
        min: 0,
        max: 10,
        restrictDateRange: true,
        Reference_field: "financialYear",
      },
      {
        id: Math.random() * 10,
        name: "Ref_No",
        label: "Doc No",
        type: "text",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Doc_Date",
        label: "Doc Date",
        type: "Date",
        min: 0,
        max: 10,
        restrictDateRange: true,
        Reference_field: "financialYear",
      },
    ],
  },
];
const DocUpload = {
  name: "Documents",
  label: "Other Details",
  fields: [
    {
      id: Math.random() * 10,
      name: "File",
      label: "",
    },
  ],
};

let tableHeader = ["Cr/Db", "Account Name", "Debit", "Credit", "No", "Delete"];

let TableHeader = [
  {
    id: Math.random() * 10,
    name: "JurnalHeader_1",
    fields: [
      {
        id: Math.random() * 10,
        name: "Cr/Dr",
        label: "Cr/Dr",
        type: "inputdrop",
        dropdowncontent: ["Cr", "Dr"],
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: `Account_Name${Math.random() * 10}`,
        label: "Account Name",
        type: "InputDropForQuery",
        masterName: "All_Accounts",

        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Debit",
        label: "Debit",
        type: "number",
      },
      {
        id: Math.random() * 10,
        name: "Credit",
        label: "Credit",
        type: "number",
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "JurnalHeader_2",
    fields: [
      {
        id: Math.random() * 10,
        name: "Cr/Dr",
        label: "Cr/Dr",
        type: "inputdrop",
        dropdowncontent: ["Cr", "Dr"],
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: `Account_Name${Math.random() * 10}`,
        label: "Account Name",
        type: "InputDropForQuery",
        masterName: "All_Accounts",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Debit",
        label: "Debit",
        type: "number",
      },
      {
        id: Math.random() * 10,
        name: "Credit",
        label: "Credit",
        type: "number",
      },
    ],
  },
];

export { DocUpload, Data, tableHeader, TableHeader };

// let Data = [
//   {
//     id: Math.random() * 10,
//     name: "Doc_Details",
//     fields: [
//       {
//         id: Math.random() * 10,
//         name: "Date",
//         label: "Date",
//         type: "Date",
//         min: 0,
//         max: 10,
//         restrictDateRange: true,
//         Reference_field: "financialYear",
//       },
//       {
//         id: Math.random() * 10,
//         name: "Invoice_No",
//         label: "Voucher No",
//         type: "text",
//         icon: "IoSettingsOutline",
//         disabled: true
//       },


//       {
//         id: Math.random() * 10,
//         name: "Ref_No",
//         label: "Doc No",
//         type: "text",
//         min: 2,
//         max: Infinity,
//       },
//       {
//         id: Math.random() * 10,
//         name: "Doc_Date",
//         label: "Doc Date",
//         type: "Date",
//         min: 0,
//         max: 10,
//         restrictDateRange: true,
//         Reference_field: "financialYear",
//       },
//     ],
//   },
// ];
// const DocUpload = {
//   name: "Documents",
//   label: "Other Details",
//   fields: [
//     {
//       id: Math.random() * 10,
//       name: "File",
//       label: "",
//     },
//   ],
// };

// let tableHeader = ["Cr/Db", "Account Name", "Debit", "Credit", "No", "Delete"];

// let TableHeader = [
//   {
//     id: Math.random() * 10,
//     name: "JurnalHeader_1",
//     fields: [
//       {
//         id: Math.random() * 10,
//         name: "Cr/Dr",
//         label: "Cr/Dr",
//         type: "inputdrop",
//         dropdowncontent: ["Cr", "Dr"],
//         min: 2,
//         max: Infinity,
//       },
//       {
//         id: Math.random() * 10,
//         name: `Account_Name${Math.random() * 10}`,
//         label: "Account Name",
//         type: "InputDropForQuery",
//         masterName: "All_Accounts",

//         min: 2,
//         max: Infinity,
//       },
//       {
//         id: Math.random() * 10,
//         name: "Debit",
//         label: "Debit",
//         type: "number",
//       },
//       {
//         id: Math.random() * 10,
//         name: "Credit",
//         label: "Credit",
//         type: "number",
//       },
//     ],
//   },
//   {
//     id: Math.random() * 10,
//     name: "JurnalHeader_2",
//     fields: [
//       {
//         id: Math.random() * 10,
//         name: "Cr/Dr",
//         label: "Cr/Dr",
//         type: "inputdrop",
//         dropdowncontent: ["Cr", "Dr"],
//         min: 2,
//         max: Infinity,
//       },
//       {
//         id: Math.random() * 10,
//         name: `Account_Name${Math.random() * 10}`,
//         label: "Account Name",
//         type: "InputDropForQuery",
//         masterName: "All_Accounts",
//         min: 2,
//         max: Infinity,
//       },
//       {
//         id: Math.random() * 10,
//         name: "Debit",
//         label: "Debit",
//         type: "number",
//       },
//       {
//         id: Math.random() * 10,
//         name: "Credit",
//         label: "Credit",
//         type: "number",
//       },
//     ],
//   },
// ];


// const Configuration = [
//   {
//     id: Math.random() * 10,
//     name: "Config_Details",
//     fields: [
//       {
//         id: Math.random() * 10,
//         name: "Default_Voucher_Series",
//         label: "Default Voucher Series",
//         type: "InputDropForQuery",
//         masterName: "Voucher_Series",
//         variable: {
//           Voucher_Type: "Journal Voucher",
//         },
//         min: 0,
//         max: Infinity,
//         isRequired: true,
//       },
//     ],
//   },
// ];

// export { DocUpload, Data, tableHeader, TableHeader, Configuration };
